module.exports = __webpack_public_path__ + "static/img/icon-number-4.310998f0.svg";